/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import AppBar from "@mui/material/AppBar";
// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import SimmmpleLogo from "examples/Icons/SimmmpleLogo";
// Vision UI Dashboard React base styles
import breakpoints from "assets/theme/base/breakpoints";
// Vision UI Dashboard React components
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
// Vision UI Dashboard React icons
import { IoCube } from "react-icons/io5";
import { IoDocument } from "react-icons/io5";
import { IoBuild } from "react-icons/io5";
// Vision UI Dashboard React example components
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useEffect, useState } from "react";
import VuiButton from "components/VuiButton";
import { Dialog, DialogActions, DialogContent, Icon } from "@mui/material";
import useCommon from "hooks/useCommon";
import { logoutUser } from "store/slice/userSlice";

function Header() {
  const { STORE, DISPATCH } = useCommon();
  const { user } = STORE((state) => state.user);
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);
  const [tabValue, setTabValue] = useState(0);

  const handleOpenLogoutDialog = () => setLogoutDialogOpen(true);
  const handleCloseLogoutDialog = () => setLogoutDialogOpen(false);

  const handleConfirmLogout = () => {
    setLogoutDialogOpen(false);
    DISPATCH(logoutUser());
    // NAVIGATE("/authentication/sign-in");
    // window.location.reload();
  };

  useEffect(() => {
    // A function that sets the orientation state of the tabs.
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.lg
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal");
    }

    /** 
     The event listener that's calling the handleTabsOrientation function when resizing the window.
    */
    window.addEventListener("resize", handleTabsOrientation);

    // Call the handleTabsOrientation function to set the state with the initial value.
    handleTabsOrientation();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, [tabsOrientation]);

  const handleSetTabValue = (event, newValue) => setTabValue(newValue);

  return (
    <VuiBox position="relative">
      <DashboardNavbar />
      <Card
        sx={{
          px: 3,
          mt: 2,
        }}
      >
        <Grid
          container
          alignItems="center"
          justifyContent="start"
          sx={({ breakpoints }) => ({
            [breakpoints.up("xs")]: {
              gap: "16px",
            },
            [breakpoints.up("xs")]: {
              gap: "0px",
            },
            [breakpoints.up("xl")]: {
              gap: "0px",
            },
          })}
        >
          <Grid
            item
            xs={12}
            md={1.7}
            lg={1.5}
            xl={1.2}
            xxl={0.8}
            display="flex"
            justifyContent={{ xs: "center", md: "flex-start" }}
            alignItems="center"
            // sx={({ breakpoints }) => ({
            //   [breakpoints.only("xs")]: {
            //     justifyContent: "center",
            //     alignItems: "center",
            //   },
            // })}
          >
            <SimmmpleLogo size="64px" />
          </Grid>
          <Grid item xs={12} md={4.3} lg={4} xl={3.8} xxl={7}>
            <VuiBox
              height="100%"
              mt={1}
              lineHeight={1}
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems={{ xs: "center", md: "flex-start" }}
              textAlign={{ xs: "center", md: "left" }}
            >
              <VuiTypography variant="lg" fontWeight="bold">
                {user?.name}
              </VuiTypography>
              <VuiTypography variant="button" fontWeight="regular">
                {user?.email}
              </VuiTypography>
            </VuiBox>
          </Grid>
          {/* <Grid
            item
            xs={3}
            md={3}
            lg={3}
            xl={6}
            xxl={4}
            sx={{
              ml: "auto",
              mr: "auto",
              display: {
                xs: "none",
                sm: "none",
                md: "flex",
              },
            }}
            justifyContent="flex-end"
            alignItems="center"
          >
            <VuiBox>
              <VuiButton variant="gradient" color="error" onClick={handleOpenLogoutDialog}>
                <Icon className="text-error">logout</Icon>&nbsp; Logout
              </VuiButton>
            </VuiBox>
          </Grid> */}
          {/* <Grid item xs={12} md={6} lg={6.5} xl={6} xxl={4} sx={{ ml: "auto" }}>
            <AppBar position="static">
              <Tabs
                orientation={tabsOrientation}
                value={tabValue}
                onChange={handleSetTabValue}
                sx={{ background: "transparent", display: "flex", justifyContent: "flex-end" }}
              >
                <Tab label="OVERVIEW" icon={<IoCube  size="16px" />} />
                <Tab label="TEAMS" icon={<IoDocument  size="16px" />} />
                <Tab label="PROJECTS" icon={<IoBuild  size="16px" />} />
              </Tabs>
            </AppBar>
          </Grid> */}
        </Grid>
      </Card>

      <Dialog
        open={logoutDialogOpen}
        onClose={handleCloseLogoutDialog}
        aria-labelledby="logout-dialog-title"
        sx={{
          "& .MuiDialog-paper": {
            p: 1,
            borderRadius: "14px",
            background: "linear-gradient(135deg, rgba(255,255,255,0.10), rgba(255,255,255,0.05))",
            backdropFilter: "blur(20px)",
            WebkitBackdropFilter: "blur(20px)",
            border: "1px solid rgba(255, 255, 255, 0.2)",
            // borderRadius: borders.borderRadius.lg,
            boxShadow: "0 8px 32px 0 rgba(0, 0, 0, 0.25)",
          },
        }}
      >
        {/* <DialogTitle id="logout-dialog-title">Log out?</DialogTitle> */}
        <DialogContent p={5}>
          <VuiTypography variant="body2">
            Are you sure you want to logout of your account?
          </VuiTypography>
        </DialogContent>
        <DialogActions>
          <VuiButton variant="gradient" color="secondary" onClick={handleCloseLogoutDialog}>
            Cancel
          </VuiButton>
          <VuiButton variant="gradient" color="error" onClick={handleConfirmLogout}>
            Logout
          </VuiButton>
        </DialogActions>
      </Dialog>
    </VuiBox>
  );
}

export default Header;
